module.exports = __webpack_public_path__ + "static/logo-nom-11a7fb77a3de0f0c7f6bf1b1b4cc8de8.png";